import { createCheckoutInitActions as e, initialCheckoutInitState as o } from "./actions/checkoutInit.action.js";
import { createCheckoutActions as r, initialCheckoutState as a } from "./actions/checkout.action.js";
import { createDashboardDataActions as n, initialDashboardDataState as c } from "./actions/dashboard.action.js";
import { createMedicineFiltersActions as m, initialMedicineFiltersState as s } from "./actions/medicineFilters.action.js";
import { createNotificationActions as f, initialNotificationState as p } from "./actions/notification.action.js";
import { createPatientInformationActions as l, initialPatientInformationState as u } from "./actions/patientInformation.action.js";
import { createPrescriptionRequestActions as h, initialPrescriptionRequestState as S } from "./actions/prescriptionRequest.action.js";
import { createUserActions as A, initialUserState as d } from "./actions/user.action.js";
import { create as k } from "zustand";
var N = k()((t, i) => ({
  user: d,
  notification: p,
  checkout: a,
  checkoutInit: o,
  dashboardData: c,
  medicineFilters: s,
  patientInformation: u,
  prescriptionRequest: S,
  ...A(t),
  ...f(t),
  ...r(t),
  ...e(t),
  ...n(t),
  ...m(t),
  ...l(t, i),
  ...h(t)
}));
export {
  N as useWebStore
};

//# sourceMappingURL=webStore.js.map